/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlogManagerCreateTagRequest } from '../models/BlogManagerCreateTagRequest';
import type { BlogManagerCreateTagResponseApiRespoonse } from '../models/BlogManagerCreateTagResponseApiRespoonse';
import type { BlogManagerListTagRequest } from '../models/BlogManagerListTagRequest';
import type { BlogManagerListTagResponseApiRespoonse } from '../models/BlogManagerListTagResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class BlogManagerTagService {

    /**
     * タグ一覧
     * @param requestBody
     * @returns BlogManagerListTagResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminTag(
        requestBody: BlogManagerListTagRequest,
    ): CancelablePromise<BlogManagerListTagResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/tag',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * タグの新規登録
     * @param requestBody
     * @returns BlogManagerCreateTagResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminTagCreate(
        requestBody: BlogManagerCreateTagRequest,
    ): CancelablePromise<BlogManagerCreateTagResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/tag/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
